export default "__VITE_ASSET__B2muaC7g__"